/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-array-index-key */

import MainLayout from 'components/MainLayout'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { Container } from 'components/layout/Grid/'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { commonFunctions } from 'utils/CommonFunctions'
import { headerTitleName } from 'utils/headerTitleName'

class Documents extends Component {
  static propTypes = {
    routes: PropTypes.array.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    getDocuments: PropTypes.func.isRequired,
    documents: PropTypes.object.isRequired,
  }
  componentDidMount() {
  }
  bannerProps = () => {
    const { routes, history, location, match, path } = this.props
    return {
      name: headerTitleName(this.props.currentUser, 'Documents'),
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const { routes, currentUser } = this.props
    // return (<div>Not Implemented</div>)
    // const currentUser = (this.props.selectedPartner.employeeid && this.props.currentUser.IsAdmin ? this.props.selectedPartner : this.props.currentUser)
    return (
      <div>
        <MainLayout
          bannerNavProps={{ ...this.bannerProps() }}
          // partnerSideBarInfo={this.props.partnerSideBarInfo}
          partnerSideBarInfo={commonFunctions.checkPartnerSideBar(this.props)}
        >
          <Container>
            {routes.map((route, i) => (
              <RouteWithSubRoutes
                key={i}
                {...route}
                currentUser={currentUser}
              />
            ))}
          </Container>
        </MainLayout>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  // errorMessage: state.errorMessage,
  // documents: state.documents,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, {
  // resetErrorMessage,
  // setErrorMessage,
  // getDocuments,
})(Documents))



// WEBPACK FOOTER //
// ./src/containers/Documents.js